// todo - consider moving this logic to SSR, just like we did with productType and the custom flags
import { useBrand } from '~/composables/useBrand';
import { useDivisionCategoryFlags } from '~/modules/featureControl/composables/useDivisionCategoryFlags';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import messages from '../constants/messages';

export const useCallCenter = (isAvailable: boolean) => {
  const { isMcom } = useBrand();
  const { isFineJewelryCategory } = useDivisionCategoryFlags();
  const { isBeautyPhoneNumberEnabled, isBigTicketPhoneNumberEnabled } = useFeatureEligibility();
  // we only display phone number for beauty on unavailable products
  const showCallCenterBanner = isMcom && !!(isFineJewelryCategory || (!isAvailable && isBeautyPhoneNumberEnabled) || isBigTicketPhoneNumberEnabled);

  const callCenterMessage = (() => {
    if (!isAvailable && isBeautyPhoneNumberEnabled) return messages.callCenterBeautyUnavailableMessageMCOM;

    if (isFineJewelryCategory) {
      return isAvailable ? messages.callCenterJewelryMessage : messages.callCenterJewelryUnavailableMessageMCOM;
    }

    if (isBigTicketPhoneNumberEnabled) {
      return isAvailable ? messages.callCenterBigTicketMessageMCOM : messages.callCenterBigTicketUnavailableMessageMCOM;
    }
    return '';
  })();

  return {
    showCallCenterBanner,
    callCenterMessage,
  };
};

export default useCallCenter;
